import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { DamageReport } from '@models/damage-report';
import { DamageReportsService } from '../damage-reports.service';

export const selectContractForDamageReportsResolveFn: ResolveFn<DamageReport[]> = (route: ActivatedRouteSnapshot) => {
    const damageReportsService = inject(DamageReportsService);
    const contractId = parseInt('' + route.params.contractId, 10);

    if (typeof contractId === 'number') {
        damageReportsService.selectContract(contractId);

        return damageReportsService.damagesForSelectedContract$;
    }
    throw new Error('selectContractForDamageReportsResolveFn: no valid contractId');
};
